export enum PaymentTypesCard {
    VISA = "Visa",
    MASTERCARD = "MasterCard",
    MAESTRO = "Maestro"
} 